var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 31,
    viewBox: "0 0 45 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.2991 30.5979C39.7927 29.4822 38.5641 29.0823 35.9725 28.2129C34.8168 27.8252 34.4182 27.6577 34.3998 27.552C34.3843 27.4629 34.7439 26.9854 35.3688 26.2654C36.8779 24.5263 36.8776 24.7331 35.3731 22.9501C33.0343 20.1785 23.6767 9.47899 23.4992 9.3735C23.2911 9.2499 23.4497 9.08404 19.6437 13.4042C14.6643 19.056 14.5116 19.1776 13.45 18.3354C12.6315 17.6861 0.529228 3.66567 0.181766 2.96431C-0.476751 1.63496 0.763539 -0.223343 2.14553 0.0220165C2.83026 0.14352 3.26346 0.606485 9.49014 7.86982C14.052 13.1912 14.1655 13.3204 14.2793 13.3204C14.331 13.3204 16.1484 11.343 18.3179 8.9263C22.4296 4.34607 22.7693 4.01032 23.357 3.94768C23.9685 3.88244 24.1906 4.07514 26.6079 6.76838C28.8179 9.23061 35.1056 16.4659 38.6251 20.5965C39.6018 21.7427 39.5198 21.7386 40.5445 20.6925C42.2314 18.9704 42.3262 18.9038 42.4763 19.337C42.5203 19.4637 42.8443 20.8505 43.1963 22.4186C43.5484 23.9867 44.0022 26.0055 44.2047 26.9049C44.7259 29.2186 45.045 30.8466 44.9948 30.9367C44.9192 31.0724 44.5735 31.0033 43.2991 30.5979Z",
    fill: "#EC2E00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFall);
export default __webpack_public_path__ + "static/media/fall.5b2f5609539284a8901e428e7be22c2f.svg";
export { ForwardRef as ReactComponent };